import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AccountingService } from 'src/app/all-modules/accounting/service/accounting.service';
import { SpinnerService } from '../../services/spinner.service';
import { CommonToastService } from '../../services/common-toast.service';
import { CommonService } from '../../services/common.service';
import { Router } from '@angular/router';
import { accountingDashboardSOListModel, accountingDashboardViewModel, accountingDTO, accountingSOListDTO } from 'src/app/all-modules/accounting/models/accounting.model';
import { COMMON_CONSTANTS, DATE_FORMAT_CONSTATNS, JOB_TYPE_CONSTANTS, MESSAGE_CATEGORY_CONSTATNS, MODULE_CONSTANTS, ROLE_CONSTANTS } from '../../constants/constant';
import { TuiDay, TuiDayRange } from '@taiga-ui/cdk';
import moment from 'moment-timezone';
import { FormControl } from '@angular/forms';
import { ApiResponse, ItemPerPage } from '../../common-model/common.model';
import { ColumnMode, DatatableComponent, SelectionType, SortType } from '@siemens/ngx-datatable';

@Component({
    selector: 'app-dashboard-accounting',
    templateUrl: './dashboard-accounting.component.html',
    styleUrl: './dashboard-accounting.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardAccountingComponent {
  accountingInfo!: accountingDashboardViewModel;
  soList: accountingDashboardSOListModel[] = [];
  soListOriginal: accountingDashboardSOListModel[] = [];
  readonly startDateSelection = new FormControl();
  startDate: string = "";
  endDate: string = "";
  isFirstTime = true;
  maxDate: any;
  isOpenSOListDialog = false;
  isLoadingSOListDialog = false;
  selectedServiceOrderId = "";
  isOpenClearSubcontractorJob = false;
  isLoadingClearSubcontractorJob = false;
  DAY_NAME_MONTH_DAY_YEAR = DATE_FORMAT_CONSTATNS.DAY_NAME_MONTH_DAY_YEAR;
  SUB_CONTRACTOR = JOB_TYPE_CONSTANTS.SUB_CONTRACTOR;
  isOpenSubcontractorJob = false;
  GRID_HIGH_LIGHT_COLOR = COMMON_CONSTANTS.GRID_HIGH_LIGHT_COLOR;
  quickSearch = '';
  scrollBarHorizontal = window.innerWidth < 1200;
  gridSelectionType!: SelectionType;
  currentPageLimit: number = 10;
  pageLimitOptions: ItemPerPage[] = COMMON_CONSTANTS.PAGE_OPTIONS_LIST;
  selectedValue = COMMON_CONSTANTS.PAGE_OPTIONS_LIST[1];
  SortType = SortType;
  rows = [];
  ColumnMode = ColumnMode;
  @ViewChild(DatatableComponent) public ngxTable!: any;
  isLoading: boolean = false;

  constructor(
    private router: Router,
    private accountingService: AccountingService,
    private commonService: CommonService,
    private spinnerService: SpinnerService,
    private commonToastService: CommonToastService
  ) {
    
  }
  ngOnInit() {
    this.startDateSelection.setValue(new TuiDayRange(this.commonService.getTUIDayFormat(localStorage.getItem("todaysDate")), this.commonService.getTUIDayFormat(localStorage.getItem("todaysDate"))));
    this.maxDate = this.commonService.getTUIDayFormat(localStorage.getItem("todaysDate"));
    this.getDashboardInfo();
    this.startDateSelection.valueChanges.subscribe(value => {
      if (!this.isFirstTime) {
        if (this.commonService.isNotNULLEmptyUndefind(value)) {
          this.getDashboardInfo();
          this.setDates();
        }
      }
    });
    this.setDates();
  }
  closeSOListDialog() {
    this.soList = [];
    this.isOpenSOListDialog = false;
    this.isLoadingSOListDialog = false;
  }
  setDates() {
    if (this.commonService.isNotNULLEmptyUndefind(this.startDateSelection.value)) {
      const fromDT = new TuiDay(this.startDateSelection.value.from.year, this.startDateSelection.value.from.month,
        this.startDateSelection.value.from.day).toString();
      let startDate = moment(fromDT, 'DD.MM.YYYY').format(DATE_FORMAT_CONSTATNS.YYYY_MM_DD_MOMENT);
      this.startDate = this.commonService.geWeekStartByDate(startDate);
      const toDT = new TuiDay(this.startDateSelection.value.to.year, this.startDateSelection.value.to.month,
        this.startDateSelection.value.to.day).toString();
      let endDate = moment(toDT, 'DD.MM.YYYY').format(DATE_FORMAT_CONSTATNS.YYYY_MM_DD_MOMENT);
      this.endDate = this.commonService.geWeekEndByDate(endDate);
    }
  }
  getBillingEntryReportAccess() {
    let count = this.commonService.getModuleAccess().filter(r => r.moduleKey === MODULE_CONSTANTS.BILLING_ENTRY_REPORT).length;
    if (count > 0) {
      return true;
    }
    return false;
  }
  getPayrollEntryReportAccess() {
    let count = this.commonService.getModuleAccess().filter(r => r.moduleKey === MODULE_CONSTANTS.PAYROLL_ENTRY_REPORT).length;
    if (count > 0) {
      return true;
    }
    return false;
  }
  getPayrollEntrySnapshotAccess() {
    let count = this.commonService.getModuleAccess().filter(r => r.moduleKey === MODULE_CONSTANTS.PAYROLL_ENTRY_SNAPSHOT).length;
    if (count > 0) {
      return true;
    }
    return false;
  }
  goToPayrollEntryReport() {
    let url = "job-planning/payroll-entry-report";
    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }
  goToPayrollEntrySnapshot() {
    let url = "job-planning/payroll-entry-snapshot";
    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }
  goToBillingEntryReport() {
    let url = "job-planning/billing-entry-report";
    this.router.navigate([]).then(result => { window.open(url, '_blank'); });
  }
  getDashboardInfo() {
    let obj: accountingDTO = {
      isLastCalendarWeek: false,
      startDate: null,
      endDate: null,
    };
    if (this.commonService.isNotNULLEmptyUndefind(this.startDateSelection.value)) {
      const fromDT = new TuiDay(this.startDateSelection.value.from.year, this.startDateSelection.value.from.month,
        this.startDateSelection.value.from.day).toString();
      obj.startDate = moment(fromDT, 'DD.MM.YYYY').format(DATE_FORMAT_CONSTATNS.YYYY_MM_DD_MOMENT);

      const toDT = new TuiDay(this.startDateSelection.value.to.year, this.startDateSelection.value.to.month,
        this.startDateSelection.value.to.day).toString();
      obj.endDate = moment(toDT, 'DD.MM.YYYY').format(DATE_FORMAT_CONSTATNS.YYYY_MM_DD_MOMENT);
    }
    if (this.isFirstTime) {
      obj.isLastCalendarWeek = true;
    }
    this.spinnerService.show();
    this.accountingService.getAccountingDashboardInfo(obj).subscribe({
      next: (response: accountingDashboardViewModel) => {
        this.accountingInfo = response;
        if (this.isFirstTime) {
          this.startDateSelection.setValue(new TuiDayRange(this.commonService.getTUIDayFormat(moment(this.accountingInfo.startDate).format("YYYY-MM-DD")), this.commonService.getTUIDayFormat(moment(this.accountingInfo.endDate).format("YYYY-MM-DD"))));
          this.setDates();
        }
      },
      complete: () => {
        setTimeout(() => {
          this.spinnerService.hide();
          this.isFirstTime = false;
        });
      },
      error: (error) => {
        this.spinnerService.hide();
        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.ACCOUNTING, error?.message);
        }
      }
    });
  }
  getDashboardSOList(key: string) {
    this.isOpenSubcontractorJob = false;
    let obj: accountingSOListDTO = {
      endDate: this.endDate,
      isBillingNotSubmitted: key === "BL" ? true : false,
      isHybrid: key === "HY" ? true : false,
      isInvoice: key === "IN" ? true : false,
      isOutstanding: key === "OUT" ? true : false,
      isSubContractor: key === "SUB" ? true : false,
      isTotal: key === "TOT" ? true : false,
      startDate: this.startDate
    };
    if (obj.isSubContractor) {
      this.isOpenSubcontractorJob = true;
    }
    // if (this.commonService.isNotNULLEmptyUndefind(this.startDateSelection.value)) {
    //   const fromDT = new TuiDay(this.startDateSelection.value.from.year, this.startDateSelection.value.from.month,
    //     this.startDateSelection.value.from.day).toString();
    //   obj.startDate = moment(fromDT, 'DD.MM.YYYY').format(DATE_FORMAT_CONSTATNS.YYYY_MM_DD_MOMENT);

    //   const toDT = new TuiDay(this.startDateSelection.value.to.year, this.startDateSelection.value.to.month,
    //     this.startDateSelection.value.to.day).toString();
    //   obj.endDate = moment(toDT, 'DD.MM.YYYY').format(DATE_FORMAT_CONSTATNS.YYYY_MM_DD_MOMENT);
    // }
    this.soList = [];
    this.isLoadingSOListDialog = true;
    this.isOpenSOListDialog = true;
    this.accountingService.getAccountingDashboardSOList(obj).subscribe({
      next: (response: accountingDashboardSOListModel[]) => {
        this.soList = response;
        this.soListOriginal = response;
      },
      complete: () => {
        setTimeout(() => {
          this.isLoadingSOListDialog = false;
        });
      },
      error: (error) => {
        this.isLoadingSOListDialog = false;
        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.ACCOUNTING, error?.message);
        }
      }
    });
  }
  getBillingNotSubmted(totalBillNotSubmittedCompanyJobCount: number, totalSubcontractorJobCount: number) {
    return totalBillNotSubmittedCompanyJobCount + totalSubcontractorJobCount;
  }
  openClearSubcontractorJob(serviceOrderId: string) {
    this.isOpenClearSubcontractorJob = true;
    this.selectedServiceOrderId = serviceOrderId;
  }
  closeClearSubcontractorJob() {
    this.isOpenClearSubcontractorJob = false;
    this.isLoadingClearSubcontractorJob = false;
    this.selectedServiceOrderId = "";
  }
  clearSubcontractorJobCount() {
    this.isLoadingClearSubcontractorJob = true;
    this.accountingService.accountingClearSubcontractorJobCount(this.selectedServiceOrderId).subscribe({
      next: (response: ApiResponse) => {
        this.commonToastService.showToasterMessage(response.msgCategoryKey, response.msgCategoryTitle, response.message);
        this.closeSOListDialog();
        this.closeClearSubcontractorJob();
        this.getDashboardInfo();
      },
      error: (error) => {
        this.closeClearSubcontractorJob();
        if (error?.status !== 401) {
          this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.ACCOUNT_COORDINATOR, error?.message);
        }
      }
    });
  }
  onLimitChange(limit: any): void {
    if (limit !== undefined && limit !== null && limit !== "") {
      const targetValue = limit;
      this.changePageLimit(targetValue);
this.ngxTable.recalculate();
      setTimeout(() => {
        if (this.ngxTable.offset() > Math.max(Math.ceil(this.ngxTable.rowCount() / this.ngxTable.limit) - 1, 0)) {
          if (this.ngxTable !== undefined && this.ngxTable.limit !== undefined) {
            this.ngxTable.offset.set(Math.floor((this.ngxTable.rowCount()- 1) / this.ngxTable.limit));
          }
        }
      });
    }
  }
  checkIfClear(newValue: any) {
    if (!this.commonService.isNotNULLEmptyUndefind(newValue)) {
      this.soList = this.soListOriginal;
    }
  }
  filterDatatableShow(event: any) {
    const val = event.target.value.toLowerCase();
    if (!this.commonService.isNotNULLEmptyUndefind(val)) {
      this.soList = this.soListOriginal;
      this.ngxTable.offset.set(0);
      return;
    }
    // filter our data
    const temp = this.soListOriginal.filter(function (d) {
      return (d.serviceOrderFullNumber.indexOf(val) !== -1 ||
        d.showName.toLowerCase().indexOf(val) !== -1) || !val;
    });

    // update the rows
    this.soList = temp;
    // Whenever the filter changes, always go back to the first page
    this.ngxTable.offset.set(0);
  }
  changePageLimit(limit: any): void {
    this.currentPageLimit = parseInt(limit, 10);
  }
}
